import { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'

import { fetchTagsDocumentsModel } from '../../../main/usecases'
import {
  CategoriesTagsCustomModelsModel,
  TagsCustomModelsModel
} from '../../../domain/models'

import HelperSidebarItem from './helper-sidebar-item'

import {
  IconTagSvg,
  IconXSvg,
  IconArrowLeftSvg
} from '../../assets/icons/svgComponents'

import * as S from './styles'

function HelperSidebar() {
  const [helperSidebar, setHelperSidebar] = useState(false)
  const [helperSidebarData, setHelperSidebarData] =
    useState<CategoriesTagsCustomModelsModel>(
      {} as CategoriesTagsCustomModelsModel
    )
  const [dropdown, setDropdown] = useState<any>({
    patient: false,
    service: false,
    psychologist: false
  })
  const navigate = useLocation()

  const showHelperSidebar = () => setHelperSidebar(!helperSidebar)

  useEffect(() => {
    setHelperSidebar(false)
  }, [navigate.pathname])

  useEffect(() => {
    setDropdown({
      patient: false,
      service: false,
      psychologist: false
    })
  }, [helperSidebar])

  useEffect(() => {
    ;(async () => {
      try {
        const responseToTagsDocumentsModel: TagsCustomModelsModel[] =
          await fetchTagsDocumentsModel().load()

        const filtedDataPatient = responseToTagsDocumentsModel.filter(
          (item: any) => item.categoria === 'paciente'
        )

        const filtedDataService = responseToTagsDocumentsModel.filter(
          (item: any) => item.categoria === 'servico'
        )

        const filtedDataPsychologist = responseToTagsDocumentsModel.filter(
          (item: any) => item.categoria === 'psicologo'
        )

        setHelperSidebarData({
          paciente: filtedDataPatient,
          servico: filtedDataService,
          psicologo: filtedDataPsychologist
        })
      } catch (error) {
        console.error(error)
      }
    })()
  }, [])

  return helperSidebar ? (
    <S.HelperSidebar>
      <S.CloseButton className="close-button">
        <button onClick={showHelperSidebar}>
          <IconXSvg />
        </button>
      </S.CloseButton>
      <S.SidebarContent className={dropdown.patient ? ' dropActive' : ''}>
        <div
          className="sidebar-content-title"
          onClick={() =>
            setDropdown({
              ...dropdown,
              patient: !dropdown.patient
            })
          }
        >
          Dados do Paciente
          <IconArrowLeftSvg />
        </div>
        {helperSidebarData.paciente.map((item) => (
          <HelperSidebarItem key={item.cdLegenda} item={item} />
        ))}
      </S.SidebarContent>
      <S.SidebarContent className={dropdown.service ? ' dropActive' : ''}>
        <div
          className="sidebar-content-title"
          onClick={() =>
            setDropdown({
              ...dropdown,
              service: !dropdown.service
            })
          }
        >
          Dados da avaliação
          <IconArrowLeftSvg />
        </div>
        {helperSidebarData.servico.map((item) => (
          <HelperSidebarItem key={item.cdLegenda} item={item} />
        ))}
      </S.SidebarContent>
      <S.SidebarContent className={dropdown.psychologist ? ' dropActive' : ''}>
        <div
          className="sidebar-content-title"
          onClick={() =>
            setDropdown({
              ...dropdown,
              psychologist: !dropdown.psychologist
            })
          }
        >
          Dados do Psicólogico
          <IconArrowLeftSvg />
        </div>
        {helperSidebarData.psicologo.map((item) => (
          <HelperSidebarItem key={item.cdLegenda} item={item} />
        ))}
      </S.SidebarContent>
    </S.HelperSidebar>
  ) : (
    <S.HelpContainer onClick={showHelperSidebar}>
      <S.HelpButton title="Ver legendas">
        <IconTagSvg />
      </S.HelpButton>
      <span>Legendas</span>
    </S.HelpContainer>
  )
}

export default HelperSidebar
